import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MappingFormComponent } from './mapping-form/mapping-form.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', component: MappingFormComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MappingRoutingModule {}
